import * as yup from 'yup';

export const transferValidator = yup.object().shape({
  advisor: yup.object({
    id: yup.string().required('ra.validation.required').nullable(),
  }),
  id: yup.string().required(),
  organization: yup.string().required('ra.validation.required').nullable(),
});
